<mat-card class="p-0">
    <form [formGroup]="doctoCForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
            <!-- Botões de Ação Superior -->
            <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px">
                <button mat-raised-button color="accent" (click)="close()">
                    <mat-icon>arrow_back</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
                </button>
                <button mat-raised-button color="primary" [matTooltip]="'Salvar Lançamento'"
                    (click)="save(false, false); $event.preventDefault()">
                    <mat-icon>save</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
                </button>
                <!-- Botões Itens e Parcelas restaurados para telas não-mobile -->
                <button mat-raised-button color="primary" (click)="openItensPopUp(doctoCForm)"
                    *ngIf="!layoutConf.isMobile">
                    <mat-icon>format_list_numbered</mat-icon>
                    {{ "LCTO_ITENS" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="openParcelas(doctoCForm)"
                    *ngIf="!layoutConf.isMobile">
                    <mat-icon>payments</mat-icon>
                    {{ "PARCELAS" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="previa(); $event.preventDefault();"
                    *ngIf="!layoutConf.isMobile && this.dfe">
                    <mat-icon>assignment_turned_in</mat-icon> DF-e {{ "PREVIA" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="autoriza(); $event.preventDefault();"
                    *ngIf="!layoutConf.isMobile && this.dfe">
                    <mat-icon>assignment_turned_in</mat-icon> DF-e {{ "AUTORIZA" | translate }}
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Mais Opções">
                    <mat-icon>more_vert</mat-icon>
                    Mais Opções
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openItensPopUp(doctoCForm); $event.preventDefault();"
                        *ngIf="layoutConf.isMobile">
                        <mat-icon>format_list_numbered</mat-icon> {{ "LCTO_ITENS" | translate }}
                    </button>
                    <button mat-menu-item (click)="openParcelas(doctoCForm); $event.preventDefault();"
                        *ngIf="layoutConf.isMobile">
                        <mat-icon>payments</mat-icon> {{ "PARCELAS" | translate }}
                    </button>
                    <button mat-menu-item (click)="openAnexoUploadListPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>attachment</mat-icon> Anexos
                    </button>
                    <button mat-menu-item
                        (click)="openAnexoUploadListPopUpCadastro(doctoCForm); $event.preventDefault();">
                        <mat-icon>attachment</mat-icon> Anexo(s) Cadastrais
                    </button>
                    <button mat-menu-item (click)="openTotaisPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>request_quote</mat-icon> {{ "LCTO_TOTAIS" | translate }}
                    </button>
                    <!-- <button mat-menu-item (click)="print(1); $event.preventDefault();">
                        <mat-icon>print</mat-icon> Formulário 1
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario1Menu">
                        <mat-icon>description</mat-icon> Formulário 1
                    </button>
                    <!-- Submenu para opções de envio via WhatsApp -->
                    <mat-menu #formulario1Menu="matMenu">
                        <button mat-menu-item (click)="print(1); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(1)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                    <!-- <button mat-menu-item (click)="print(2); $event.preventDefault();">
                       <mat-icon>print</mat-icon> Formulário 2
                     </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario2Menu">
                        <mat-icon>description</mat-icon> Formulário 2
                    </button>
                    <mat-menu #formulario2Menu="matMenu">
                        <button mat-menu-item (click)="print(2); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(2)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                    <!-- <button mat-menu-item (click)="print(3); $event.preventDefault();">
                    <mat-icon>print</mat-icon> Formulário 3
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario3Menu">
                        <mat-icon>description</mat-icon> Formulário 3
                    </button>
                    <mat-menu #formulario3Menu="matMenu">
                        <button mat-menu-item (click)="print(3); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(3)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                 
                    <!-- <button mat-raised-button color="primary" (click)="previa(); $event.preventDefault();"
                        *ngIf="!layoutConf.isMobile && this.dfe">
                        <mat-icon>assignment_turned_in</mat-icon> DF-e {{ "PREVIA" | translate }}
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="previaMenu">
                        <mat-icon>description</mat-icon> Prévia
                    </button>
                    <mat-menu #previaMenu="matMenu">
                        <button mat-menu-item (click)="previa(); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData('previa')); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>

                    <!-- <button mat-menu-item (click)="print(0); $event.preventDefault();">
                        <mat-icon>print</mat-icon> DF-e Imprimir
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="dfeImprimirMenu">
                        <mat-icon>description</mat-icon> DF-e Imprimir
                    </button>
                    <mat-menu #dfeImprimirMenu="matMenu">
                        <button mat-menu-item (click)="print(0); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(0)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                   
                    <button mat-menu-item color="primary" (click)="autoriza(); $event.preventDefault();">
                        <mat-icon>assignment_turned_in</mat-icon> DF-e {{ "AUTORIZA" | translate }}
                    </button>
                    <button mat-menu-item color="warn" (click)="cancela(); $event.preventDefault();">
                        <mat-icon>cancel_presentation</mat-icon> DF-e {{ "CANCELAR_NF" | translate }}
                    </button>
                    <button mat-menu-item (click)="consultarNF(); $event.preventDefault();">
                        <mat-icon>search</mat-icon> DF-e Consultar
                    </button>
                    <button mat-menu-item (click)="enviaEmail(); $event.preventDefault();">
                        <mat-icon>send</mat-icon> DF-e Enviar e-mail
                    </button>
                    <button mat-menu-item (click)="openTranspVolumes(doctoCForm); $event.preventDefault();">
                        <mat-icon>directions_bus</mat-icon> {{ "TRANSP_VOLUMES" | translate }}
                    </button>
                    <button mat-menu-item (click)="openDadosNfe(doctoCForm); $event.preventDefault();">
                        <mat-icon>receipt</mat-icon> {{ "DADOS_NFE" | translate }}
                    </button>
                    <button mat-menu-item (click)="openDoctosRefPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>description</mat-icon> {{ "DOCTOS_REF" | translate }}
                    </button>
                    <button mat-menu-item (click)="openCartaCorrecao(doctoCForm); $event.preventDefault();">
                        <mat-icon>description</mat-icon> {{ "CARTA_CORRECAO" | translate }}
                    </button>
                </mat-menu>
            </div>

            <!-- Conteúdo Principal -->
            <div fxFlex="100">
                <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="tab-content">
                    <!-- Dados Básicos -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Lançamento - Dados Básicos</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Emissão</mat-label>
                                        <input matInput [matDatepicker]="picker1"
                                            [formControl]="doctoCForm.controls['emissao']">
                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1 startView="month"></mat-datepicker>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['emissao'].hasError('required') && doctoCForm.controls['emissao'].touched">
                                            Emissão é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Data entrada/saída</mat-label>
                                        <input matInput [matDatepicker]="picker2"
                                            [formControl]="doctoCForm.controls['dataentradasaida']">
                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2 startView="month"></mat-datepicker>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['dataentradasaida'].hasError('required') && doctoCForm.controls['dataentradasaida'].touched">
                                            Data entrada/saída é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Transação</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatTransacao']"
                                            (selectionChange)="onSelectionChangeFatTransacao($event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchTransacao']"
                                                    placeholderLabel="Pesquisar Transação"
                                                    noEntriesFoundLabel="Transação não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let transacao of fatTransacoes" [value]="transacao">
                                                {{ transacao?.codigo?.toString().padStart(5, '0') + " - " +
                                                transacao?.descricao?.trim() }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatTransacao'].hasError('required') && doctoCForm.controls['fatTransacao'].touched">
                                            Transação é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input [matAutocomplete]="autoSerie" matInput type="text"
                                            formControlName="serie" placeholder="Série" readonly>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['serie'].hasError('required') && doctoCForm.controls['serie'].touched">
                                            Série é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-autocomplete #autoSerie="matAutocomplete" [displayWith]="displayFnSerie"
                                        (optionSelected)="onSelectionChangeSerie($event)">
                                        <mat-option *ngIf="isLoadingSerie" class="is-loading">
                                            <mat-spinner diameter="30"></mat-spinner>
                                        </mat-option>
                                        <ng-container *ngIf="!isLoadingSerie">
                                            <mat-option *ngFor="let d of series" [value]="d">
                                                {{ d?.codigo + " - " + d?.descricao }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-autocomplete>
                                </div>
                                <div fxFlex="7" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>N° Docto</mat-label>
                                        <input matInput type="number" formControlName="numeroDocto"
                                            (focus)="$event.target.select()">
                                        <mat-error
                                            *ngIf="doctoCForm.controls['numeroDocto'].hasError('required') && doctoCForm.controls['numeroDocto'].touched">
                                            N° Docto é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="30" fxFlex.lt-md="100" fxLayout="column" fxLayoutAlign="end end"
                                    style="text-align: right;">
                                    <span class="status-highlight" style="margin-bottom: 8px;">
                                        <strong>Status:</strong> {{ (lcto?.statuslcto ?? "000") + " - " +
                                        (lcto?.statusDesc ?? "NENHUM STATUS ENCONTRADO")}}
                                    </span>
                                    <h1 *ngIf="!layoutConf.isMobile" style="margin: 0;">TOTAL: {{
                                        doctoCForm.controls['valortotalDocto'].value | currency:'BRL' }}</h1>
                                    <h3 *ngIf="layoutConf.isMobile" style="margin: 0;">TOTAL: {{
                                        doctoCForm.controls['valortotalDocto'].value | currency:'BRL' }}</h3>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Destinatário -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Destinatário</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="40" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Destinatário</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadCadastro']"
                                            (selectionChange)="onSelectionChangeDestinatario($event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchDestinatario']"
                                                    placeholderLabel="Pesquisar Destinatário"
                                                    noEntriesFoundLabel="Destinatário não encontrado"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let d of filteredDestinatarios | async" [value]="d">
                                                {{ d?.codigo?.toString()?.padStart(9, '0') + " - " + d?.razaoSocial + "
                                                - [ " + d?.cadMun?.municipio + "/" + d?.cadMun?.uf + " ]" }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cadCadastro'].hasError('required') && doctoCForm.controls['cadCadastro'].touched">
                                            Destinatário é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="35" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Nome</mat-label>
                                        <input [imask]="maskUpper" matInput type="text" formControlName="nome"
                                            (focus)="$event.target.select()">
                                        <mat-error
                                            *ngIf="doctoCForm.controls['nome'].hasError('required') && doctoCForm.controls['nome'].touched">
                                            Nome é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>CNPJ/CPF</mat-label>
                                        <input [imask]="maskUpper" matInput type="text" formControlName="cnpjCpf"
                                            (focus)="$event.target.select()">
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cnpjCpf'].hasError('required') && doctoCForm.controls['cnpjCpf'].touched">
                                            CNPJ/CPF é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Condições -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Condições</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Vendedor</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadVendedor']"
                                            (selectionChange)="onSelectionChangeVendedor($event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchVendedor']"
                                                    placeholderLabel="Pesquisar Vendedor"
                                                    noEntriesFoundLabel="Vendedor não encontrado"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let vendedor of vendedores" [value]="vendedor">
                                                {{ vendedor?.codigo?.toString().padStart(9, '0') + " - " +
                                                vendedor?.razaoSocial }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cadVendedor'].hasError('required') && doctoCForm.controls['cadVendedor'].touched">
                                            Vendedor é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Condição de Pagamento</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatCondPg']"
                                            (selectionChange)="onSelectionChangeCondPg($event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchCondPg']"
                                                    placeholderLabel="Pesquisar Condição"
                                                    noEntriesFoundLabel="Condição não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let c of filteredCondpgs | async" [value]="c">
                                                {{ c?.codigo?.toString().padStart(5, '0') + " - " + c?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatCondPg'].hasError('required') && doctoCForm.controls['fatCondPg'].touched">
                                            Condição de Pagamento é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Lista de Preço</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatListaPreco']"
                                            (selectionChange)="onSelectionChangeListaPreco($event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchLisPre']"
                                                    placeholderLabel="Pesquisar Lista"
                                                    noEntriesFoundLabel="Lista não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let l of listaPrecos" [value]="l">
                                                {{ l?.codigo?.toString().padStart(5, '0') + " - " + l?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatListaPreco'].hasError('required') && doctoCForm.controls['fatListaPreco'].touched">
                                            Lista de Preço é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Tabela de Preço</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatListaPrecoTabela']"
                                            [compareWith]="tabelaIdComparaison">
                                            <mat-option *ngFor="let tabela of tabelas" [value]="tabela">
                                                {{ tabela?.id?.tabelaId?.toString() + " - " + tabela?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Dados Adicionais -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Dados Adicionais</mat-card-title>
                        <mat-card-content>
                            <mat-tab-group mat-align-tabs="start">
                                <mat-tab label="Dados Adicionais">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Dados Adicionais</mat-label>
                                        <textarea matInput formControlName="dadosadicionais" rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                                <mat-tab label="Dados Adicionais - Fisco">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Dados Adicionais - Fisco</mat-label>
                                        <textarea matInput formControlName="dadosadicionaiscontribuinte"
                                            rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                                <mat-tab label="Outros Dados">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Outros Dados</mat-label>
                                        <textarea matInput formControlName="outrosDados" rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                            </mat-tab-group>
                        </mat-card-content>
                    </mat-card>

                    <!-- Total -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Total</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row" fxLayoutAlign="end center">
                                <h1 *ngIf="!layoutConf.isMobile">TOTAL: {{ doctoCForm.controls['valortotalDocto'].value
                                    | currency:'BRL' }}</h1>
                                <h3 *ngIf="layoutConf.isMobile">TOTAL: {{ doctoCForm.controls['valortotalDocto'].value |
                                    currency:'BRL' }}</h3>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <!-- Botões Inferiores -->
        <mat-card-actions>
            <div fxFlex="100" class="action-buttons">
                <button mat-raised-button color="primary" [matTooltip]="'Salvar Lançamento'"
                    (click)="save(false, false); $event.preventDefault()">
                    <mat-icon>save</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
                </button>
            </div>
        </mat-card-actions>
    </form>
</mat-card>